<template>
	<Popper
		v-click-outside="closePopover"
		:isVisible="popoverVisible"
		placement="bottom-end"
		@keydown.escape="closePopover"
	>
		<BaseTooltip placement="bottom" text="Invite team members">
			<button data-test="invite-button" class="button-icon" @click="onButtonClick">
				<BaseIcon name="mono/invite" />
			</button>
		</BaseTooltip>
		<template #popup>
			<BasePopover title="Invite to the team" data-test="invite-to-team-popover">
				<template #footer>
					<InviteMemberInPopover formOpen location="Invite Button Popover" @close="closePopover" />
				</template>
			</BasePopover>
		</template>
	</Popper>
</template>

<script>
import {defineAsyncComponent} from 'vue'

import Popper from 'shared/components/Popper.vue'

export default {
	name: 'ButtonInvite',
	components: {
		Popper,
		InviteMemberInPopover: defineAsyncComponent(() => import('shared/components/InviteMemberInPopover.vue')),
	},
	data() {
		return {
			popoverVisible: false,
		}
	},
	methods: {
		onButtonClick() {
			if (!this.$store.workspace.canInviteFullMember) {
				this.$routerHelpers.navigateToWorkspaceSettings('members')
				return
			}
			this.popoverVisible = !this.popoverVisible
		},
		closePopover() {
			this.popoverVisible = false
		},
	},
}
</script>
